/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestLoginRouteImport } from './routes/test-login'
import { Route as TestRouteImport } from './routes/test'
import { Route as SuporteLoginRouteImport } from './routes/suporte-login'
import { Route as SuporteRouteImport } from './routes/suporte'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LivroId_pedidoRouteImport } from './routes/livro.$id_pedido'
import { Route as AuthHub_loginRouteImport } from './routes/auth.$hub_login'

const TestLoginRoute = TestLoginRouteImport.update({
  id: '/test-login',
  path: '/test-login',
  getParentRoute: () => rootRouteImport,
} as any)
const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const SuporteLoginRoute = SuporteLoginRouteImport.update({
  id: '/suporte-login',
  path: '/suporte-login',
  getParentRoute: () => rootRouteImport,
} as any)
const SuporteRoute = SuporteRouteImport.update({
  id: '/suporte',
  path: '/suporte',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LivroId_pedidoRoute = LivroId_pedidoRouteImport.update({
  id: '/livro/$id_pedido',
  path: '/livro/$id_pedido',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthHub_loginRoute = AuthHub_loginRouteImport.update({
  id: '/auth/$hub_login',
  path: '/auth/$hub_login',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/suporte': typeof SuporteRoute
  '/suporte-login': typeof SuporteLoginRoute
  '/test': typeof TestRoute
  '/test-login': typeof TestLoginRoute
  '/auth/$hub_login': typeof AuthHub_loginRoute
  '/livro/$id_pedido': typeof LivroId_pedidoRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/suporte': typeof SuporteRoute
  '/suporte-login': typeof SuporteLoginRoute
  '/test': typeof TestRoute
  '/test-login': typeof TestLoginRoute
  '/auth/$hub_login': typeof AuthHub_loginRoute
  '/livro/$id_pedido': typeof LivroId_pedidoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/suporte': typeof SuporteRoute
  '/suporte-login': typeof SuporteLoginRoute
  '/test': typeof TestRoute
  '/test-login': typeof TestLoginRoute
  '/auth/$hub_login': typeof AuthHub_loginRoute
  '/livro/$id_pedido': typeof LivroId_pedidoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/suporte'
    | '/suporte-login'
    | '/test'
    | '/test-login'
    | '/auth/$hub_login'
    | '/livro/$id_pedido'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/suporte'
    | '/suporte-login'
    | '/test'
    | '/test-login'
    | '/auth/$hub_login'
    | '/livro/$id_pedido'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/suporte'
    | '/suporte-login'
    | '/test'
    | '/test-login'
    | '/auth/$hub_login'
    | '/livro/$id_pedido'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  SuporteRoute: typeof SuporteRoute
  SuporteLoginRoute: typeof SuporteLoginRoute
  TestRoute: typeof TestRoute
  TestLoginRoute: typeof TestLoginRoute
  AuthHub_loginRoute: typeof AuthHub_loginRoute
  LivroId_pedidoRoute: typeof LivroId_pedidoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test-login': {
      id: '/test-login'
      path: '/test-login'
      fullPath: '/test-login'
      preLoaderRoute: typeof TestLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suporte-login': {
      id: '/suporte-login'
      path: '/suporte-login'
      fullPath: '/suporte-login'
      preLoaderRoute: typeof SuporteLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suporte': {
      id: '/suporte'
      path: '/suporte'
      fullPath: '/suporte'
      preLoaderRoute: typeof SuporteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/livro/$id_pedido': {
      id: '/livro/$id_pedido'
      path: '/livro/$id_pedido'
      fullPath: '/livro/$id_pedido'
      preLoaderRoute: typeof LivroId_pedidoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/$hub_login': {
      id: '/auth/$hub_login'
      path: '/auth/$hub_login'
      fullPath: '/auth/$hub_login'
      preLoaderRoute: typeof AuthHub_loginRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  SuporteRoute: SuporteRoute,
  SuporteLoginRoute: SuporteLoginRoute,
  TestRoute: TestRoute,
  TestLoginRoute: TestLoginRoute,
  AuthHub_loginRoute: AuthHub_loginRoute,
  LivroId_pedidoRoute: LivroId_pedidoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
